export const playingBar = {
  'Now playing view': 'Estás escuchando',
  Lyrics: 'Letras',
  Queue: 'Fila de reproducción',
  'Connect to a device': 'Conectar a un dispositivo',
  Mute: 'Silenciar',
  Unmute: 'Activar sonido',
  'Full Screen': 'Expandir pantalla',
  Home: 'Inicio',
  'Source code': 'Código fuente',
  'Your Library': 'Tu biblioteca',
  'Now playing': 'Reproduciendo',
  Next: 'A continuación',
  Skills: 'Habilidades',
  Experience: 'Experiencia',
  Description: 'Descripción',
  Images: 'Imágenes',
  'Related projects': 'Proyectos relacionados',
  'Exit full screen': 'Salir de pantalla completa',
};
